import React from 'react';
import {
  LineChart, Line, BarChart, Bar, PieChart, Pie, AreaChart, Area,
  XAxis, YAxis, CartesianGrid, Tooltip, Legend, Cell,
  RadarChart, Radar, PolarGrid, PolarAngleAxis, PolarRadiusAxis,
  ScatterChart, Scatter, ZAxis,
  ComposedChart
} from 'recharts';

// Sample data - you would replace this with your actual data
const lineData = [
  { name: 'Jan', value: 400 }, { name: 'Feb', value: 300 },
  { name: 'Mar', value: 600 }, { name: 'Apr', value: 800 }
];

const pieData = [
  { name: 'Group A', value: 400 },
  { name: 'Group B', value: 300 },
  { name: 'Group C', value: 300 },
  { name: 'Group D', value: 200 }
];

const scatterData = [
  { x: 100, y: 200, z: 200 },
  { x: 120, y: 100, z: 260 },
  { x: 170, y: 300, z: 400 },
  { x: 140, y: 250, z: 280 },
  { x: 150, y: 400, z: 500 }
];

const radarData = [
  { subject: 'Math', A: 120, B: 110 },
  { subject: 'Chinese', A: 98, B: 130 },
  { subject: 'English', A: 86, B: 130 },
  { subject: 'Geography', A: 99, B: 100 },
  { subject: 'Physics', A: 85, B: 90 }
];

const COLORS = ['#0088FE', '#00C49F', '#FFBB28', '#FF8042'];

export const BasicLineChart = () => (
  <div className="p-4 bg-white rounded-lg shadow">
    <h3 className="text-lg font-semibold mb-4">Line Chart</h3>
    <LineChart width={500} height={300} data={lineData}>
      <CartesianGrid strokeDasharray="3 3" />
      <XAxis dataKey="name" />
      <YAxis />
      <Tooltip />
      <Legend />
      <Line type="monotone" dataKey="value" stroke="#8884d8" strokeWidth={2} />
    </LineChart>
  </div>
);

export const BasicAreaChart = () => (
  <div className="p-4 bg-white rounded-lg shadow">
    <h3 className="text-lg font-semibold mb-4">Area Chart</h3>
    <AreaChart width={500} height={300} data={lineData}>
      <CartesianGrid strokeDasharray="3 3" />
      <XAxis dataKey="name" />
      <YAxis />
      <Tooltip />
      <Area type="monotone" dataKey="value" stroke="#8884d8" fill="#8884d8" />
    </AreaChart>
  </div>
);

export const BasicBarChart = () => (
  <div className="p-4 bg-white rounded-lg shadow">
    <h3 className="text-lg font-semibold mb-4">Bar Chart</h3>
    <BarChart width={500} height={300} data={lineData}>
      <CartesianGrid strokeDasharray="3 3" />
      <XAxis dataKey="name" />
      <YAxis />
      <Tooltip />
      <Legend />
      <Bar dataKey="value" fill="#8884d8" />
    </BarChart>
  </div>
);

export const BasicPieChart = () => (
  <div className="p-4 bg-white rounded-lg shadow">
    <h3 className="text-lg font-semibold mb-4">Pie Chart</h3>
    <PieChart width={500} height={300}>
      <Pie
        data={pieData}
        cx={250}
        cy={150}
        labelLine={false}
        outerRadius={100}
        fill="#8884d8"
        dataKey="value"
      >
        {pieData.map((entry, index) => (
          <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
        ))}
      </Pie>
      <Tooltip />
      <Legend />
    </PieChart>
  </div>
);

export const BasicScatterChart = () => (
  <div className="p-4 bg-white rounded-lg shadow">
    <h3 className="text-lg font-semibold mb-4">Scatter Chart</h3>
    <ScatterChart width={500} height={300}>
      <CartesianGrid strokeDasharray="3 3" />
      <XAxis dataKey="x" type="number" name="x" />
      <YAxis dataKey="y" type="number" name="y" />
      <ZAxis dataKey="z" type="number" range={[60, 400]} name="z" />
      <Tooltip cursor={{ strokeDasharray: '3 3' }} />
      <Scatter name="Values" data={scatterData} fill="#8884d8" />
    </ScatterChart>
  </div>
);

export const BasicRadarChart = () => (
  <div className="p-4 bg-white rounded-lg shadow">
    <h3 className="text-lg font-semibold mb-4">Radar Chart</h3>
    <RadarChart width={500} height={300} cx="50%" cy="50%" outerRadius="80%" data={radarData}>
      <PolarGrid />
      <PolarAngleAxis dataKey="subject" />
      <PolarRadiusAxis angle={30} domain={[0, 150]} />
      <Radar name="Student A" dataKey="A" stroke="#8884d8" fill="#8884d8" fillOpacity={0.6} />
      <Radar name="Student B" dataKey="B" stroke="#82ca9d" fill="#82ca9d" fillOpacity={0.6} />
      <Legend />
    </RadarChart>
  </div>
);

export const ComposedChartExample = () => (
  <div className="p-4 bg-white rounded-lg shadow">
    <h3 className="text-lg font-semibold mb-4">Composed Chart</h3>
    <ComposedChart width={500} height={300} data={lineData}>
      <CartesianGrid stroke="#f5f5f5" />
      <XAxis dataKey="name" />
      <YAxis />
      <Tooltip />
      <Legend />
      <Area type="monotone" dataKey="value" fill="#8884d8" stroke="#8884d8" />
      <Bar dataKey="value" barSize={20} fill="#413ea0" />
      <Line type="monotone" dataKey="value" stroke="#ff7300" />
    </ComposedChart>
  </div>
);

const timeSeriesData = [
    { date: '2019-01', value1: 20, value2: 15, value3: 10, value4: 12 },
    { date: '2019-06', value1: 40, value2: 30, value3: 25, value4: 28 },
    { date: '2020-01', value1: 60, value2: 45, value3: 40, value4: 35 },
    { date: '2020-06', value1: 129.2, value2: 125.2, value3: 105.3, value4: 95.8 }
  ];
  
  const barData = [
    { name: 'Category 1', value1: 60, value2: 40 },
    { name: 'Category 2', value1: 85, value2: 15 },
    { name: 'Category 3', value1: 87, value2: 13 },
    { name: 'Category 4', value1: 80, value2: 20 },
    { name: 'Category 5', value1: 84, value2: 16 },
    { name: 'Category 6', value1: 60, value2: 40 }
  ];
  
  const categoryScatterData = [
    { x: -0.06, y: 0.3, category: 'value1' },
    { x: 0.02, y: 0.8, category: 'value1' },
    { x: 0.04, y: 0.4, category: 'value1' },
    { x: 0.08, y: 0.6, category: 'value2' },
    { x: 0.12, y: 0.4, category: 'value2' },
    { x: 0.14, y: 0.8, category: 'value2' }
  ];
  
  const trendData = [
    { x: 10, y1: 20, y2: 25 },
    { x: 30, y1: 35, y2: 40 },
    { x: 50, y1: 50, y2: 45 },
    { x: 70, y1: 75, y2: 60 }
  ];

  const areaData = [
    { date: '2020-01', area1: 33, area2: 15, area3: 10, area4: 5 },
    { date: '2020-02', area1: 30, area2: 25, area3: 44, area4: 66 },
    { date: '2020-03', area1: 45, area2: 35, area3: 25, area4: 20 },
    { date: '2020-04', area1: 55, area2: 22, area3: 51, area4: 25 },
    { date: '2020-05', area1: 65, area2: 55, area3: 45, area4: 35 },
    { date: '2020-06', area1: 75, area2: 65, area3: 55, area4: 90 },
  ];
  
  export const MultiLineChart = () => (
    <div className="p-4 bg-white rounded-lg shadow">
      <h3 className="text-lg font-semibold mb-4">Multi-Line Chart</h3>
      <LineChart width={500} height={300} data={timeSeriesData}>
        <CartesianGrid strokeDasharray="3 3" stroke="#f0f0f0" />
        <XAxis dataKey="date" stroke="#666" />
        <YAxis stroke="#666" />
        <Tooltip />
        <Legend />
        <Line 
          type="monotone" 
          dataKey="value1" 
          stroke="#8884d8" 
          strokeWidth={2}
          dot={false}
        />
        <Line 
          type="monotone" 
          dataKey="value2" 
          stroke="#ff6b6b" 
          strokeWidth={2}
          dot={false}
        />
        <Line 
          type="monotone" 
          dataKey="value3" 
          stroke="#82ca9d" 
          strokeWidth={2}
          dot={false}
        />
        <Line 
          type="monotone" 
          dataKey="value4" 
          stroke="#ffd700" 
          strokeWidth={2}
          dot={false}
        />
      </LineChart>
    </div>
  );
  
  export const StackedAreaChart = () => (
    <div className="p-4 bg-white rounded-lg shadow">
      <h3 className="text-lg font-semibold mb-4">Stacked Area Chart</h3>
      <AreaChart width={500} height={300} data={timeSeriesData}>
        <CartesianGrid strokeDasharray="3 3" stroke="#f0f0f0" />
        <XAxis dataKey="date" stroke="#666" />
        <YAxis stroke="#666" />
        <Tooltip />
        <Legend />
        <Area 
          type="monotone" 
          dataKey="value1" 
          stackId="1"
          stroke="#8884d8" 
          fill="#8884d8"
          fillOpacity={0.6}
        />
        <Area 
          type="monotone" 
          dataKey="value2" 
          stackId="1"
          stroke="#ff6b6b" 
          fill="#ff6b6b"
          fillOpacity={0.6}
        />
        <Area 
          type="monotone" 
          dataKey="value3" 
          stackId="1"
          stroke="#ffd700" 
          fill="#ffd700"
          fillOpacity={0.6}
        />
      </AreaChart>
    </div>
  );
  
  export const HorizontalBarChart = () => (
    <div className="p-4 bg-white rounded-lg shadow">
      <h3 className="text-lg font-semibold mb-4">Horizontal Bar Chart</h3>
      <BarChart layout="vertical" width={500} height={300} data={barData}>
        <CartesianGrid stroke="#f0f0f0" horizontal={true} vertical={false} />
        <XAxis type="number" stroke="#666" />
        <YAxis dataKey="name" type="category" stroke="#666" />
        <Tooltip />
        <Legend />
        <Bar 
          dataKey="value1" 
          fill="#82ca9d" 
          stackId="stack"
          barSize={20}
        />
        <Bar 
          dataKey="value2" 
          fill="#ccc" 
          stackId="stack"
          barSize={20}
        />
      </BarChart>
    </div>
  );
  
  export const CurvedLineChart = () => (
    <div className="p-4 bg-white rounded-lg shadow">
      <h3 className="text-lg font-semibold mb-4">Curved Line Chart</h3>
      <LineChart width={500} height={300} data={timeSeriesData}>
        <CartesianGrid strokeDasharray="3 3" stroke="#f0f0f0" />
        <XAxis dataKey="date" stroke="#666" />
        <YAxis stroke="#666" />
        <Tooltip />
        <Line 
          type="natural" 
          dataKey="value1" 
          stroke="#8884d8" 
          strokeWidth={3}
          dot={false}
          fill="#8884d8"
          fillOpacity={0.1}
        />
      </LineChart>
    </div>
  );
  
  export const CustomScatterChart = () => (
    <div className="p-4 bg-white rounded-lg shadow">
      <h3 className="text-lg font-semibold mb-4">Scatter Plot</h3>
      <ScatterChart width={500} height={300}>
        <CartesianGrid stroke="#f0f0f0" />
        <XAxis type="number" dataKey="x" stroke="#666" />
        <YAxis type="number" dataKey="y" stroke="#666" />
        <Tooltip cursor={{ strokeDasharray: '3 3' }} />
        <Legend />
        <Scatter 
          name="Value 1" 
          data={categoryScatterData.filter(d => d.category === 'value1')} 
          fill="#ff6b6b"
        />
        <Scatter 
          name="Value 2" 
          data={categoryScatterData.filter(d => d.category === 'value2')} 
          fill="#ffd700"
        />
      </ScatterChart>
    </div>
  );
  
  export const TrendLineChart = () => (
    <div className="p-4 bg-white rounded-lg shadow">
      <h3 className="text-lg font-semibold mb-4">Trend Line Chart</h3>
      <LineChart width={500} height={300} data={trendData}>
        <CartesianGrid stroke="#f0f0f0" />
        <XAxis dataKey="x" stroke="#666" />
        <YAxis stroke="#666" />
        <Tooltip />
        <Legend />
        <Line 
          type="monotone" 
          dataKey="y1" 
          stroke="#ff6b6b"
          strokeWidth={2}
          strokeDasharray="5 5"
          dot={{ fill: '#ff6b6b', r: 4 }}
        />
        <Line 
          type="monotone" 
          dataKey="y2" 
          stroke="#ffd700"
          strokeWidth={2}
          dot={{ fill: '#ffd700', r: 4 }}
        />
      </LineChart>
    </div>
  );


  export const MultiAreaChart = () => (
    <div className="p-4 bg-white rounded-lg shadow">
      <h3 className="text-lg font-semibold mb-4">Multi-Area Chart</h3>
      <AreaChart 
        width={600} 
        height={400} 
        data={areaData}
        margin={{ top: 10, right: 30, left: 0, bottom: 0 }}
      >
        <defs>
          <linearGradient id="colorArea1" x1="0" y1="0" x2="0" y2="1">
            <stop offset="5%" stopColor="#8884d8" stopOpacity={0.8}/>
            <stop offset="95%" stopColor="#8884d8" stopOpacity={0.2}/>
          </linearGradient>
          <linearGradient id="colorArea2" x1="0" y1="0" x2="0" y2="1">
            <stop offset="5%" stopColor="#82ca9d" stopOpacity={0.8}/>
            <stop offset="95%" stopColor="#82ca9d" stopOpacity={0.2}/>
          </linearGradient>
          <linearGradient id="colorArea3" x1="0" y1="0" x2="0" y2="1">
            <stop offset="5%" stopColor="#ffc658" stopOpacity={0.8}/>
            <stop offset="95%" stopColor="#ffc658" stopOpacity={0.2}/>
          </linearGradient>
          <linearGradient id="colorArea4" x1="0" y1="0" x2="0" y2="1">
            <stop offset="5%" stopColor="#ff8042" stopOpacity={0.8}/>
            <stop offset="95%" stopColor="#ff8042" stopOpacity={0.2}/>
          </linearGradient>
        </defs>
        <CartesianGrid strokeDasharray="3 3" stroke="#f0f0f0" />
        <XAxis 
          dataKey="date" 
          stroke="#666"
          tick={{ fill: '#666' }}
        />
        <YAxis 
          stroke="#666"
          tick={{ fill: '#666' }}
        />
        <Tooltip />
        <Legend />
        <Area 
          type="monotone" 
          dataKey="area1" 
          stroke="#8884d8" 
          fillOpacity={0.3}
          fill="url(#colorArea1)" 
          name="Area 1"
        />
        <Area 
          type="monotone" 
          dataKey="area2" 
          stroke="#82ca9d" 
          fillOpacity={0.3}
          fill="url(#colorArea2)" 
          name="Area 2"
        />
        <Area 
          type="monotone" 
          dataKey="area3" 
          stroke="#ffc658" 
          fillOpacity={0.3}
          fill="url(#colorArea3)" 
          name="Area 3"
        />
        <Area 
          type="monotone" 
          dataKey="area4" 
          stroke="#ff8042" 
          fillOpacity={0.3}
          fill="url(#colorArea4)" 
          name="Area 4"
        />
      </AreaChart>
    </div>
  );

const ChartCollection = () => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-6 p-6">
      <BasicLineChart />
      <BasicAreaChart />
      <BasicBarChart />
      <BasicPieChart />
      <BasicScatterChart />
      <BasicRadarChart />
      <ComposedChartExample />
      <MultiLineChart />
      <StackedAreaChart />
      <HorizontalBarChart />
      <CurvedLineChart />
      <CustomScatterChart />
      <TrendLineChart />
      <MultiAreaChart/>
    </div>
  );
};

export default ChartCollection;